import { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'
import BackToTop from '../ui/BackToTop'

interface PageLayoutProps {
  children: ReactNode
}

const PageLayout = ({ children }: PageLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <BackToTop />
    </div>
  )
}

export default PageLayout
